import { render } from "./UserDetails.vue?vue&type=template&id=078af8b8&ts=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=078af8b8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__